import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  LIST_ITEM: `${cleanedFilename(__filename)}-list-item`,
  HEADER_ROW: `${cleanedFilename(__filename)}-header-row`,
  TABLE_BODY: `${cleanedFilename(__filename)}-table-body`,
};
